<template>
  <div class="grid grid-cols-2 tablet-h:grid-cols-4 gap-[22px]">
    <div v-for="attribute in props.attributes" :key="attribute.key">
      <div
        class="font-secondary text-[12px] text-gray-500 leading-[20px] mb-1.5"
      >
        {{ attribute.key }}
      </div>
      <div class="font-secondary leading-[20px]">
        {{ parseAttribute(attribute.value) }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Attribute } from '@/shared/graphql/router/graphql'
import { formatTimestamp } from '@/shared/utils/datetime'

const props = defineProps<{
  attributes: Attribute[]
}>()

const parseAttribute = (value: string | number) => {
  if (
    typeof value === 'string' &&
    value.length === 10 &&
    /^\d+$/.test(value) &&
    !isNaN(parseInt(value)) &&
    new Date(parseInt(value))
  ) {
    return formatTimestamp(parseInt(`${value}000`))
  }

  return value
}
</script>
